const linkAccountPage = `plus_link_account_page(uid: "blt2fda4f016d196889") {
  banner_text
  disclaimer
  features
  imageConnection {
    edges {
      node {
        url
      }
    }
  }
  offer {
    heading
    subheading
  }
  terms {
    heading
    text
  }
  title
  url
  cta {
    text
  }
}`;

export default linkAccountPage;
